module.exports = __webpack_public_path__ + "officialStatic/img/auth5.62f693c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/auth5.jpg
// module id = Bkk8
// module chunks = 0